/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Order_ReturnedInputs */

const vi_error_order_returned = /** @type {(inputs: Error_Order_ReturnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn đã hoàn, không thu tiền nữa.`)
};

/**

* @param {Error_Order_ReturnedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_order_returned = /** @type {((inputs?: Error_Order_ReturnedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Order_ReturnedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_order_returned(inputs)
});